<!-- [nzListStyle]="{ 'width.px': 4000, 'height.px': 500 }" -->
<nz-transfer style="width: 1100px;" [nzDataSource]="items"  [nzRender]="render"
    (nzSelectChange)="select($event)" (nzChange)="change($event)">
    <ng-template #render let-item>
        <div style="display: inline-block;">
        <div class="name">{{ item.name }}</div>
        <div class="metric">{{ item.metric }}</div>
        <div class="price">{{ item.price }}</div>
        <div class="status">
            <nz-icon nzType="{{ item.icon }}" />
        </div>
    </div>
    </ng-template>
</nz-transfer>

<button nz-button  nzType="primary" (click)="submit()">Publish Price</button>